/**
 * "Merge Documents" menu action: opens the document merger modal.
 *
 * @module handleMergeDocumentsClick
 */
import { GeneralOrderDetails } from "../../../../data-model/medicalPaOrdersModel";
import { ModalId } from "../../../../enums/modalId";
import { setOpenedModalId } from "../../../../redux/slice/modalSlice";
import { AppDispatch } from "../../../../redux/store/store";

/**
 * Opens {@link ModalId.DOCUMENT_MERGER_MODAL} from the three-dots menu.
 *
 * Seeds the modal with the order's `document_page_mapping`, clinical PDF
 * storage path, org/patient identifiers, and title fields (payer, patient
 * name, date of service) so {@link DocumentMerger} can preview the packet,
 * pre-fill the merged download name, and persist the merged download.
 *
 * @param dispatch - Redux dispatch used to set the active modal id
 * @param generalOrderDetails - Order whose clinical document feeds the merge panel
 * @param payerName - Resolved payer display name for the default merged PDF title
 */
export const handleMergeDocumentsClick = (
  dispatch: AppDispatch,
  generalOrderDetails: GeneralOrderDetails,
  payerName: string,
) => {
  const documentsMappings =
    generalOrderDetails?.clinical_document?.document_page_mapping ?? [];
  const documentSource =
    generalOrderDetails?.clinical_document?.file_path ?? "";
  dispatch(
    setOpenedModalId({
      id: ModalId.DOCUMENT_MERGER_MODAL,
      metaData: {
        documents: documentsMappings,
        src: documentSource,
        orderId: generalOrderDetails.order_id,
        orgId: generalOrderDetails.org_id,
        patientId: generalOrderDetails.demographics?.patient_id ?? "",
        payerName: payerName,
        patientName:
          generalOrderDetails.demographics?.first_name +
          " " +
          generalOrderDetails.demographics?.last_name,
        dateOfService: generalOrderDetails.payload?.date_of_service,
      },
    }),
  );
};
